import { ApiGetRequest } from './api-get-request';

export class PlayerAuthRefreshRequest extends ApiGetRequest
{
    public constructor(apiBasepath: string)
    {
      super('/authorize/authrefresh', null, null, apiBasepath);
    }
}
